export var typography = function (palette) { return ({
    fontFamily: "'Inter Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: undefined,
    h2: undefined,
    h3: undefined,
    h4: undefined,
    h5: undefined,
    h6: undefined,
    body2: undefined,
    caption: undefined,
    overline: undefined,
    subtitle1: undefined,
    subtitle2: undefined,
    'text-base': {
        fontSize: 16,
    },
    'text-2xl': {
        fontSize: 24,
        fontWeight: 500,
    },
    'text-3xl': {
        fontSize: 30,
    },
    'display-2xl': {
        fontSize: 72,
        lineHeight: 1.25,
    },
    'display-xl': {
        fontSize: 60,
        lineHeight: 1.2,
    },
    'display-lg': {
        fontSize: 48,
        lineHeight: 1.25,
    },
    'display-md': {
        fontSize: 36,
        lineHeight: 1.22,
    },
    'display-sm': {
        fontSize: 32,
        lineHeight: 1.26,
        fontWeight: 600,
    },
    'display-xs': {
        fontSize: 24,
        lineHeight: 1.33,
    },
    'text-xl': {
        fontSize: 20,
        lineHeight: 1.5,
    },
    'text-lg': {
        fontSize: 18,
        lineHeight: 1.55,
    },
    'text-md': {
        fontSize: 16,
        lineHeight: 1.5,
    },
    'text-sm': {
        fontSize: 14,
        lineHeight: 1.42,
    },
    'text-xs': {
        fontSize: 12,
        lineHeight: 1.5,
    },
    get body1() {
        return this['text-md'];
    },
    allVariants: {
        color: palette.grey['800'],
        letterSpacing: '-0.2px',
    },
}); };
